import React from 'react';
import classnames from 'classnames';
import { ConnectedResidentDiscount } from './ResidentDiscount';
import { ResidentDiscountInfo } from './ResidentDiscountInfo';
import { ResidentDiscountCheckbox } from './ResidentDiscountCheckbox';
import { ABUtils } from '../../utils';
import { ResidentDiscountMessageMobile } from './ResidentDiscountMessageMobile';

export const ResidentDiscount = () => {
    const { isCssVariationMobile, isResidentDiscount, isResidentDiscountPaxType } = ABUtils.getABs();
    const wrapperClass = classnames({
        'odf-flex-container-row odf-flex-container-nogutter': true,
        'odf-space-inner-top-s odf-space-inner-bottom-s': isCssVariationMobile,
        'odf-space-outer-top-s odf-space-inner-top-m odf-space-inner-bottom-m': !isCssVariationMobile,
    });
    return (
        <ConnectedResidentDiscount>
            {({ checked, hasNonAdults, hasRegions, onChange, regionsText }) => (
                <React.Fragment>
                    {hasRegions && (
                        <React.Fragment>
                            <div className={wrapperClass}>
                                <div className="odf-flex-item odf-flex-item-align-center">
                                    {isResidentDiscount &&
                                        (
                                            <ResidentDiscountMessageMobile
                                                hasNonAdults={hasNonAdults}
                                                regionsText={regionsText}
                                                isResidentDiscountPaxType={isResidentDiscountPaxType}
                                            />
                                        )
                                    }
                                    {!isResidentDiscount &&
                                        (
                                            <ResidentDiscountCheckbox
                                                checked={checked}
                                                hasNonAdults={hasNonAdults}
                                                onChange={onChange}
                                                regionsText={regionsText}
                                            />
                                        )
                                    }
                                </div>
                            </div>
                            {!isResidentDiscount && <ResidentDiscountInfo showBullets={checked} hasNonAdults={hasNonAdults} />}
                        </React.Fragment>
                    )}
                </React.Fragment>
            )}
        </ConnectedResidentDiscount>
    );
};
